import React, { useState, useEffect } from 'react';

import { useMediaQuery } from "@mui/material";

import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import {db} from '../../firebaseConfig';

import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';                    // currency  (green)
import AccessTimeFilledIcon from '@mui/icons-material/AccessTime';                  // time      (blue) 
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';      // phone     (purple)
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';  // date      (orange)

import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import { Tooltip, styled } from '@mui/material';
import './ApplicationLifecycleManagementTile.css';

import { IconButton,Avatar,Typography, Menu, MenuItem, Box, Checkbox } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';


import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';

import { useTheme } from "@mui/material";

import { tokens } from "../../theme";

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";





const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  
  return stringToColorLight(str); // We will use the same colors
};

const stringToColorDarkOLD = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always dark by restricting them to the first half of 256
    const darkValue = value % 128;
    color += ('00' + darkValue.toString(16)).substr(-2);
  }
  return color;
};


const generateStatusColorMap = (applicationLifecycleManagements,theme) => {
  
        const statusColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        applicationLifecycleManagements.forEach(applicationLifecycleManagement => {
          if (!statusColorMap[applicationLifecycleManagement.status]) {
            statusColorMap[applicationLifecycleManagement.status] = colorFunction(applicationLifecycleManagement.status);
          }
        });
      
        return statusColorMap;
      };
      

    const generateAssociatedRequirementIdsColorMap = (applicationLifecycleManagements, AssociatedRequirementIdsMap,theme) => {
        const associatedRequirementIdsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        applicationLifecycleManagements.forEach(applicationLifecycleManagement => {
          (applicationLifecycleManagement.associatedRequirementIds || []).forEach(itemId => {
            const item = AssociatedRequirementIdsMap[itemId];
            if (item && !associatedRequirementIdsColorMap[item]) {
                associatedRequirementIdsColorMap[item] = colorFunction(item);
            }
          });
        });
        return associatedRequirementIdsColorMap;
      };
      


const Tile = ({ data, applicationLifecycleManagements, setDrawerOpen, setShowModal,setEditingData,handleDeleteSingleItem,setCollectionModalOpen,setMissingCollections,deleteSelectionModel, setDeleteSelectionModel }) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode();
  
  const [projectMap, setProjectMap] = useState({});
const [associatedRequirementIdsMap, setAssociatedRequirementIdsMap] = useState({});
const [associatedTestCaseIdsMap, setAssociatedTestCaseIdsMap] = useState({});
const [associatedTestRunIdsMap, setAssociatedTestRunIdsMap] = useState({});
const [associatedCodeReviewIdsMap, setAssociatedCodeReviewIdsMap] = useState({});


  const [statusColorMap, setStatusColorMap] = useState({});
const [associatedRequirementIdsColorMap, setAssociatedRequirementIdsColorMap] = useState({});

	
  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const projectSnapshot = await getDocs(query(collection(db, "projects"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const projectData = projectSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const projectMap = projectData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.name }), {});
	setProjectMap(projectMap);

	const associatedRequirementIdsSnapshot = await getDocs(query(collection(db, "requirements"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedRequirementIdsData = associatedRequirementIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedRequirementIdsMap = associatedRequirementIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedRequirementIdsMap(associatedRequirementIdsMap);

	const associatedTestCaseIdsSnapshot = await getDocs(query(collection(db, "testCases"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedTestCaseIdsData = associatedTestCaseIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedTestCaseIdsMap = associatedTestCaseIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedTestCaseIdsMap(associatedTestCaseIdsMap);

	const associatedTestRunIdsSnapshot = await getDocs(query(collection(db, "testRuns"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedTestRunIdsData = associatedTestRunIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedTestRunIdsMap = associatedTestRunIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedTestRunIdsMap(associatedTestRunIdsMap);

	const associatedCodeReviewIdsSnapshot = await getDocs(query(collection(db, "codeReviews"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedCodeReviewIdsData = associatedCodeReviewIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedCodeReviewIdsMap = associatedCodeReviewIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedCodeReviewIdsMap(associatedCodeReviewIdsMap);



            if (projectData.length === 0 || associatedRequirementIdsData.length === 0 || associatedTestCaseIdsData.length === 0 || associatedTestRunIdsData.length === 0 || associatedCodeReviewIdsData.length === 0) {
	let missing = [];
	if (projectData.length === 0) missing.push("projects");
	if (associatedRequirementIdsData.length === 0) missing.push("requirements");
	if (associatedTestCaseIdsData.length === 0) missing.push("testCases");
	if (associatedTestRunIdsData.length === 0) missing.push("testRuns");
	if (associatedCodeReviewIdsData.length === 0) missing.push("codeReviews");
	setMissingCollections(missing);
	setCollectionModalOpen(true);
}


            setStatusColorMap(generateStatusColorMap(applicationLifecycleManagements,theme));
setAssociatedRequirementIdsColorMap(generateAssociatedRequirementIdsColorMap(applicationLifecycleManagements, associatedRequirementIdsMap,theme));

        };
    
        fetchStaticData();
      }, []);
    
    

  
  const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
  
  const handleOpenEditRecord = (id) => {
  
    setEditingData(applicationLifecycleManagements.find(dataItem=> dataItem.id === id)); 

    if (!isMobile)
    {
      setDrawerOpen(false);
    }
    setShowModal(true);

  };

  const handleOpenDrawer = (id) => {
  
    setEditingData(applicationLifecycleManagements.find(dataItem=> dataItem.id === id)); 
    setDrawerOpen(true);
    setShowModal(false);

  };
    //*************************************************************************************************/

    const CustomTooltip = styled(({ className, ...props }) => (
      <Tooltip {...props} classes={{ popper: className }} />
    ))`
      & .MuiTooltip-tooltip {
        background-color: ${colors.greenAccent[600]};
        color:#000000;
        font-size: 13px; // Adjust the font size as needed
      }
    `;
  
  //*************************************************************************************************/

  const GridActionsCellItem = ({ id }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
  
    const handleClick = event => setAnchorEl(event.currentTarget);
    const handleClose = () => { setAnchorEl(null); setEditingData(null); };
    const handleDeleteAction = () => { handleDeleteSingleItem(id); };
    const handleEditAction = () => { setEditingData(applicationLifecycleManagements.find(dataItem=> dataItem.id === id)); setShowModal(true); };
    const handleCloneAction = () => {
      const itemToEdit = applicationLifecycleManagements.find(dataItem => dataItem.id === id);
      const clonedItem = { ...itemToEdit, id: null, name: `${itemToEdit.name} CLONED` };
      setEditingData(clonedItem);
      setShowModal(true);
    };
  
    return (
      <>
        <IconButton aria-label="more" id="long-button" aria-controls={open ? 'long-menu' : undefined} aria-expanded={open ? 'true' : undefined} aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu id="long-menu" MenuListProps={{ 'aria-labelledby': 'long-button', sx: { backgroundColor: colors.greenAccent[700] , color: colors.grey[100] } }} anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={handleCloneAction}><FileCopyIcon style={{ marginRight: 8 }} />Clone Application Lifecycle Management</MenuItem>
          <MenuItem onClick={handleDeleteAction}><DeleteIcon style={{ marginRight: 8 }} /> Delete Application Lifecycle Management</MenuItem>
          <MenuItem onClick={handleEditAction}><EditIcon style={{ marginRight: 8 }} /> Edit Application Lifecycle Management</MenuItem>
        </Menu>
      </>
    );
  };

  //*************************************************************************************************/

//USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setStatusColorMap(generateStatusColorMap(applicationLifecycleManagements,theme));
setAssociatedRequirementIdsColorMap(generateAssociatedRequirementIdsColorMap(applicationLifecycleManagements, associatedRequirementIdsMap,theme));

}, [theme.palette.mode, applicationLifecycleManagements ,associatedRequirementIdsMap]);


  const handleDeleteSelectionChange = (id) => {
   
    setDeleteSelectionModel((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };


  const formatFirestoreDate = timestamp => {

    if (timestamp != null && timestamp !== "")
    {
      const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
      const parts = dateStr.split('-');
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    } else 
    {
      return "";
    }
  };

  const formatFirestoreTime = timestamp => {

   if (timestamp != null && timestamp !== "")
   { 
        // Convert the seconds since Unix epoch to a Date object
      const date = new Date(timestamp.seconds * 1000);

      // Extract hours and minutes
      let hours = date.getHours();
      const minutes = date.getMinutes();

      // Determine AM or PM
      const period = hours >= 12 ? 'PM' : 'AM';

      // Convert hours to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'

      // Format hours and minutes as a time string in "hh:mm AM/PM" format
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes} ${period}`;
   } else
   {
    return "";
   }
  };


  const formatPhoneNumber = value => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const formatCurrencyInteger = value => {
  
    if (value != null && value !=="")
    {
      return `$${Number(value).toLocaleString()}`;
    } else 
    {
      return "";
    }
  };

  const formatCurrency = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `$${result}` : '';

      } else 
      {
        return "";
      }
  };


  
 const formatProject = value => {

    let formattedProject = "";

    if (value != null && value !=="")
    {
    formattedProject = projectMap[value];
    }
    
    return formattedProject;
 };
    
                

 const formatAssociatedRequirementIds = value => {

    let formattedAssociatedRequirementIds = "";

    if (value != null)
    {
    formattedAssociatedRequirementIds = (value|| []).map(id => associatedRequirementIdsMap[id]).join(', ') || '';
    }
    
    return formattedAssociatedRequirementIds;
 };
                              
                

 const formatAssociatedTestCaseIds = value => {

    let formattedAssociatedTestCaseIds = "";

    if (value != null)
    {
    formattedAssociatedTestCaseIds = (value|| []).map(id => associatedTestCaseIdsMap[id]).join(', ') || '';
    }
    
    return formattedAssociatedTestCaseIds;
 };
                              
                

 const formatAssociatedTestRunIds = value => {

    let formattedAssociatedTestRunIds = "";

    if (value != null)
    {
    formattedAssociatedTestRunIds = (value|| []).map(id => associatedTestRunIdsMap[id]).join(', ') || '';
    }
    
    return formattedAssociatedTestRunIds;
 };
                              
                

 const formatAssociatedCodeReviewIds = value => {

    let formattedAssociatedCodeReviewIds = "";

    if (value != null)
    {
    formattedAssociatedCodeReviewIds = (value|| []).map(id => associatedCodeReviewIdsMap[id]).join(', ') || '';
    }
    
    return formattedAssociatedCodeReviewIds;
 };
                              
                


  const generateImage = (text) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const width = 700; // Set the desired width
    const height = 400; // Set the desired height
    canvas.width = width;
    canvas.height = height;

    // Fill background with gray color
    ctx.fillStyle = '#808080'; // gray
    ctx.fillRect(0, 0, width, height);

    // Set text style and rotate canvas for diagonal text
    ctx.font = '40px Arial';
    ctx.fillStyle = '#ffffff'; // white text
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    // Translate and rotate canvas for diagonal text
    ctx.translate(width / 2, height / 2);
    ctx.rotate(-45 * Math.PI / 180); // Rotate -45 degrees for diagonal

    // Draw the name text
    ctx.fillText(text, 0, 0);

    // Convert canvas to a data URL (base64)
    return canvas.toDataURL();
  };
  
  return (
    <div className="tile" style={{ marginLeft:'0px',marginBottom: 2, padding:0, backgroundColor: colors.tileBackgroundColor, borderColor: colors.tileBorderColor }}>
      
      
      
      <div className="tile-header">
        
          
                    <Avatar className="tile-image" style={{backgroundColor:colorFunction(data.projectId), color:'#000000'}}>{formatProject(data.projectId)!=null?formatProject(data.projectId).charAt(0):""}</Avatar>
                    

        <div className="tile-info" style={{cursor: 'pointer', width:'100%'}}>
          <h3 onClick={() => handleOpenEditRecord(data.id)}>{formatProject(data.projectId)}</h3>

          <table style={{width:'100%'}}>
            <tr>
              <td> 
                <p onClick={() => handleOpenEditRecord(data.id)}>{data.id}</p>  
              </td>
              
              <td>
              {!isMobile ? ( 
                <span style={{float:"right"}}>
                <IconButton onClick={() => handleOpenDrawer(data.id)}>

                <KeyboardDoubleArrowRightIcon/>
                </IconButton>
               </span>
              ) : 
                <span>&nbsp;</span>
              }
                            
              </td>
               </tr>
               </table>
        </div>
      </div>
      
      <hr style={{border: 'none', borderTop: '1px solid #626262'}} />  

      <div className="tile-details">
      <center>
        <table>
          
          <tr>
        

        

        
        </tr>

        </table>
      </center>
      </div>

       
      <Box style={{textAlign:"left",paddingLeft:'6px'}}>
              {/*
              <Box style={{fontWeight:'100', fontSize:'14px'}}><u>PRIORITY</u></Box>
              <Box style={{fontWeight:'600', fontSize:'15px'}}>High</Box>
              */}

              <table style={{width:'100%'}}>
                  <tr>
                  <td style={{borderBottom: '1px solid #626262'}}>STATUS</td>
                  </tr>
                  <tr style={{fontWeight:'600',verticalAlign:'top'}}>
                  <td>{data.status ? data.status.toString() : ""}</td>
                  </tr>
              </table>
      </Box>
      <br></br>
              
                     

      

      <div className="tile-tags">
        <div>&nbsp;</div>
      </div>


      <Box sx={{ padding: '0px', margin: '0px', height: '5px' }}>
              <div style={{ float: 'left' }}>

              <Checkbox 
              checked={deleteSelectionModel.includes(data.id)}
              onChange={() => handleDeleteSelectionChange(data.id)}
                                    
                                    sx={{
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        '&.Mui-checked': {
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        },
                                    }}
                                    />

              </div>
      </Box>   

      <Box sx={{ padding: '0px', margin: '0px', height: '40px' }}>
              <div style={{ float: 'right' }}>
                <GridActionsCellItem {...data} />
              </div>
      </Box>

    </div>
  );
};

export default Tile;
